import { Link } from 'react-router-dom';
import './sectionHeadingWithLinkSmall.css';

function SectionHeadingWithLinkSmall(props) {
  const { heading, colorHeading, icon, linkText, link } = props;

  return (
    <div className="sectionHeadingWithLinkSmall">
      <div>
        <h3>
          {heading || ''} <span>{colorHeading || ''}</span>
        </h3>
      </div>
      <div className="border_line" />
      <div className="btn_icon_box">
        {/* dynamic icon */}
        <img src={icon || ''} alt="" />
        {/* dynamic link */}
        <Link to={link || ''}> {linkText || ''} </Link>
      </div>
    </div>
  );
}
export default SectionHeadingWithLinkSmall;
